import agronautP from "./agronautP.png";

export const SHIP_GARDEN_POST_PORTRAIT_IMAGES = [agronautP];
